<button class="btn btn-light btn-flush-left" type="button" (click)="onNewClick()">{{buttonTitle}}</button>